import { useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { GoogleMerchantSettingsFormFields } from '../helpers';

export const useMerchantSettingsFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    [GoogleMerchantSettingsFormFields.ACCOUNT_ID]: [requiredRule],
    [GoogleMerchantSettingsFormFields.DATA_SOURCE]: [requiredRule],
    [GoogleMerchantSettingsFormFields.FEED_LABEL]: [requiredRule],
    [GoogleMerchantSettingsFormFields.LANGUAGE]: [requiredRule],
    [GoogleMerchantSettingsFormFields.CURRENCY]: [requiredRule],
    [GoogleMerchantSettingsFormFields.DEFAULT_CATEGORY_ID]: [requiredRule],
  };
};
